import { render } from "./ArtistsPage.vue?vue&type=template&id=1ca23d1a"
import script from "./ArtistsPage.vue?vue&type=script&lang=js"
export * from "./ArtistsPage.vue?vue&type=script&lang=js"

import "./ArtistsPage.vue?vue&type=style&index=0&id=1ca23d1a&lang=sass"

import exportComponent from "/Users/ilya/Documents/Web/github/iTunes-Vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__